export const COLUMNS = [
    {
        accessor: 'name',
        header: 'Vendor Name',
       
    },
    {
        accessor: 'integration',
        header: 'Integration',
        render: (data: any) => data.integration || '-',
    },
    {
        accessor: 'phone',
        header: 'Phone',
        render: (data: any) => data.phone || '-',
    },
    {
        accessor: 'email',
        header: 'Email',
        render: (data: any) => data.email || '-',
    },
    {
        accessor: 'isActive',
        header: 'Status',
        render: (data: any) => data.isActive === false ? 'Inactive' : 'Active',
    },
];
